var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 103,
    viewBox: "0 0 77 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1635_7719)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5668 36.5672C67.6153 44.4593 66.2597 54.5108 61.1131 61.0949C66.5168 38.406 52.9611 13.6441 27.8871 0C43.0291 32.4376 0.0687064 34.2301 10.3111 72.2822C5.78662 68.3867 4.08291 58.3321 4.57773 52.7145C-6.68054 72.6314 3.84437 96.4962 25.0432 103.001C16.865 95.5838 16.4536 81.986 25.2624 74.5691C20.8399 92.4934 39.2125 89.7561 32.7504 79.1583C27.874 70.8529 33.3171 50.8541 44.5452 45.6097C37.9689 68.5559 62.3505 74.5691 56.9074 94.7857C56.206 97.375 54.9018 99.7613 53.1016 101.749C82.5604 91.0564 81.5785 57.1763 64.5668 36.5672Z",
    fill: "#D41411"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1635_7719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.4851,
    height: 103,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWild);
export default __webpack_public_path__ + "static/media/icon_wild.ee268a7bdf1bd847d405eeb76c1c05ff.svg";
export { ForwardRef as ReactComponent };